import React from 'react';

const ItemColor = ({ color, className }) => {
  const colorObject = color && color.option && color.option.color;
  if (!colorObject) return <div />;

  let classNames = [ 'color' ];
  if (colorObject.name) {
    classNames.push(`color-${colorObject.name.toLowerCase()}`);
  }

  if (className) classNames.push(className);

  return (
    <div className={ classNames.join(' ') }>
      <span style={{ backgroundColor: '#' + colorObject.rgb }}/>
    </div>
  );
};

export default ItemColor;



/** WEBPACK FOOTER **
 ** ./src/views/ProductModal/item_color.js
 **/